import React from "react";

interface AccordionTitleProps {
  title: React.ReactNode;
  titleClassName?: string;
}

const AccordionTitle: React.FC<AccordionTitleProps> = ({
  title,
  titleClassName = "",
}) => {
  return <div className={titleClassName}>{title}</div>;
};

export default AccordionTitle;
